<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <h1 class="text-uppercase font-weight-bold my-2">Listado de Cámaras</h1>
      <server-filterable-table
        :downloadeable="false"
        :column_display="column_display"
        :columns="columns"
        :filterable="filterable"
        :headings="headings"
        :listColumns="listColumns"
        :url="url"
        @on-loading="loading = $event"
        :action-buttons="action_buttons"
        @on-arrow-right-action="(e) => openRoom(e.id, e.name)"
      />
    </div>
  </div>
</template>

<script>
import ServerFilterableTable from "@/bagno_views/ServerFilterableTable";
export default {
  name: "LotList",
  components: {
    ServerFilterableTable
  },
  data() {
    return {
      title: "Listado de Cámaras",
      loading: false,
      action_buttons: ["arrow-right"],
      columns: ["id", "name", "actions"],
      filterable: [],
      headings: {},
      listColumns: {}
    };
  },
  computed: {
    url() {
      return "/storage/room/";
    }
  },
  methods: {
    openRoom(id, name) {
      this.$router.push({ name: "camara-layout", params: { id, name } });
    }
  }
};
</script>

<style></style>
